import { graphql } from '@/generated/gql';

export const UPDATE_FILTER_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateFilter($id: uuid!, $isFavorite: Boolean) {
    update_filters_by_pk(pk_columns: { id: $id }, _set: { isFavorite: $isFavorite }) {
      id
      isFavorite
    }
  }
`);
